import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ClaimPage } from './pages/ClaimPage';
import { DashboardPage } from './pages/DashboardPage';
import { CertificateDetailPage } from './pages/CertificateDetailPage';
import { ExternalCredentialDetailPage } from './pages/ExternalCredentialDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { VerifyPage } from './pages/VerifyPage';
import { SharePage } from './pages/SharePage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { CVBuilderPage } from './pages/CVBuilderPage';
import { LearningPathPage } from './pages/LearningPathPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { RegisterInstancePage } from './pages/RegisterInstancePage';
import { MyRegistrationPage } from './pages/MyRegistrationPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { Layout } from './components/Layout';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="claim/:candidateCode" element={<ClaimPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="certificates/:certificateId" element={<CertificateDetailPage />} />
          <Route path="external-credentials/:credentialId" element={<ExternalCredentialDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="verify/:verificationCode" element={<VerifyPage />} />
          <Route path="share/:shareCode" element={<SharePage />} />
          <Route path="admin" element={<AdminDashboardPage />} />
          <Route path="cv-builder" element={<CVBuilderPage />} />
          <Route path="learning-path" element={<LearningPathPage />} />
          <Route path="welcome" element={<OnboardingPage />} />
          <Route path="register/:instanceId" element={<RegisterInstancePage />} />
          <Route path="min-pamelding/:token" element={<MyRegistrationPage />} />
          <Route path="404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
